import { render, staticRenderFns } from "./impedance-table.vue?vue&type=template&id=0cd80e63&"
import script from "./impedance-table.vue?vue&type=script&lang=js&"
export * from "./impedance-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports